module.exports = __webpack_public_path__ + "img/photo_2020-08-27_17-23-59.da187910.jpg";